var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDirectUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.6934 28.8867L18.0534 26.5667C16.76 25.9267 15.2534 25.9267 13.96 26.5667L9.32005 28.8867C5.33338 30.8733 1.13338 26.5933 3.21338 22.66L4.30671 20.6067C4.45338 20.3267 4.69338 20.1 4.98671 19.9667L21.84 12.3667C22.5334 12.06 23.3467 12.34 23.6934 13.0067L28.7734 22.66C30.8534 26.5933 26.6667 30.8733 22.6934 28.8867Z",
    fill: "#F9BA33"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M20.8001 10.7533L9.76011 15.7267C8.52011 16.2867 7.26677 14.9533 7.90677 13.7533L11.9601 6.06C13.6801 2.79333 18.3468 2.79333 20.0668 6.06L21.4934 8.78C21.8668 9.51333 21.5468 10.42 20.8001 10.7533Z",
    fill: "#F9BA33"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirectUp);
export default __webpack_public_path__ + "static/media/direct-up.6e69e53d3048af04a104bf5dad3e5aa1.svg";
export { ForwardRef as ReactComponent };